import { useTranslation } from 'react-i18next'
import { Radio } from 'lucide-react'
import { KnowledgeAskCitation } from '@digital-twins/shared-types'
import { Text } from '@/components/ui/Text'
import { citationSocialPost } from '../KnowledgeHubPage/social/SocialCitationPostMeta'

interface ThreadTrackerProvenanceProps {
  citations?: Array<KnowledgeAskCitation>
}

/**
 * For an org with social trackers: whether this answer cites posts its
 * trackers collected, and from which trackers, or none of them.
 */
export function ThreadTrackerProvenance(props: ThreadTrackerProvenanceProps) {
  const { citations = [] } = props
  const { t } = useTranslation('app')

  const posts = new Map<string, string | null>()
  for (const citation of citations) {
    const post = citationSocialPost(citation)
    if (post) {
      posts.set(post.postToken, post.trackerName)
    }
  }
  const trackerNames = [
    ...new Set([...posts.values()].filter((name): name is string => Boolean(name))),
  ]
  const isFromTrackers = posts.size > 0

  return (
    <Text
      as="p"
      size="xs"
      color="muted"
      className="flex items-center gap-1.5"
      data-testid="thread-tracker-provenance"
      data-from={isFromTrackers ? 'tracker' : 'other'}
    >
      <Radio className="h-3.5 w-3.5 shrink-0" aria-hidden />
      {isFromTrackers
        ? trackerNames.length > 0
          ? t('socialListening.provenance.fromTrackersNamed', {
              count: posts.size,
              trackers: trackerNames.join(', '),
            })
          : t('socialListening.provenance.fromTrackers', { count: posts.size })
        : t('socialListening.provenance.notFromTrackers')}
    </Text>
  )
}
